// extracted by mini-css-extract-plugin
module.exports = {"h2":"tryus-module--h2--1EMBo","h3":"tryus-module--h3--3HClo","main":"tryus-module--main--2FR2W","image":"tryus-module--image--1a3PR"};